module.exports = __webpack_public_path__ + "assets/favicon-96x96.ebbf1698.png";